import { render, staticRenderFns } from "./TabOverrideIndividu.vue?vue&type=template&id=30a8b77f&scoped=true&"
import script from "./TabOverrideIndividu.vue?vue&type=script&lang=js&"
export * from "./TabOverrideIndividu.vue?vue&type=script&lang=js&"
import style0 from "./TabOverrideIndividu.vue?vue&type=style&index=0&id=30a8b77f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a8b77f",
  null
  
)

export default component.exports